import { Injectable, Input } from "@angular/core";
import { MixinInjectorConstructor } from "./mixin";

export const RequiredMixin = <CLAZZ extends MixinInjectorConstructor>(Clazz: CLAZZ) => {
  @Injectable()
  abstract class Required extends Clazz {
    @Input()
    required?: boolean;
  }

  return Required;
};

export const RequiredMixinInputs = ["required"];
